import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
  })
export class LocationStorageCoreService {
    constructor() {
     }

     public get(branch: string): void {
        this.setLocalItem(branch);
     }

     public setLocalItem( data: string): void {
        if (this.getLocalBranch()) {
          localStorage.removeItem('branch');
        }
        localStorage.setItem('branch', JSON.stringify(data));
      }
    
      public getLocalBranch(): string | undefined {
        const item = localStorage.getItem('branch'); 
        if (item) {
          return JSON.parse(item) as unknown as string;
        }
        return undefined;
      }
}